var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"main"}},[_c('div',{staticClass:"container py-4 py-lg-4"},[_c('div',{staticClass:"col-md-12"},_vm._l((_vm.courses),function(course){return _c('div',{key:course.title,staticClass:"row"},[_c('course-card',_vm._b({},'course-card',course,false))],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }